import React from "react";
import { Link } from "react-router-dom";

export const VirtualaccountTable = ({ virtualaccount }) => {
	return (
		<div className="transac-table">
			<table className="table">
				<thead>
					<tr>
						<th>REFERENCE</th>
						<th>BANK NAME</th>
						<th>ACCOUNT NUMBER</th>
						<th>ACCOUNT NAME</th>
						<th>ACTION</th>
					</tr>
				</thead>
				<tbody>
					{virtualaccount?.results?.map((account) => (
						<tr key={account.tracking_reference}>
							<td>{account.tracking_reference}</td>
							<td>{account.bank_name}</td>
							<td>{account.account_number}</td>
							<td>{account.account_name}</td>
							<td>
								<Link
									to={`/virtual-account/${account.account_number}`}
									className="transaction_type trans-default"
								>
									{" "}
									View{" "}
								</Link>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
